import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Flex Justify Content Icons - Box-based visual representations
// =============================================================================

export function JustifyStart(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "JustifyStart",
    viewBox: "0 0 16 16",
    path: (
      <>
        <rect
          x="2"
          y="5"
          width="3"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="6"
          y="5"
          width="3"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function JustifyCenter(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "JustifyCenter",
    viewBox: "0 0 16 16",
    path: (
      <>
        <rect
          x="3.5"
          y="5"
          width="3"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="9.5"
          y="5"
          width="3"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function JustifyEnd(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "JustifyEnd",
    viewBox: "0 0 16 16",
    path: (
      <>
        <rect
          x="7"
          y="5"
          width="3"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="11"
          y="5"
          width="3"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function JustifySpaceBetween(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "JustifySpaceBetween",
    viewBox: "0 0 16 16",
    path: (
      <>
        <rect
          x="2"
          y="5"
          width="3"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="11"
          y="5"
          width="3"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function JustifySpaceAround(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "JustifySpaceAround",
    viewBox: "0 0 16 16",
    path: (
      <>
        <rect
          x="3"
          y="5"
          width="3"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="10"
          y="5"
          width="3"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function JustifySpaceEvenly(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "JustifySpaceEvenly",
    viewBox: "0 0 16 16",
    path: (
      <>
        <rect
          x="2"
          y="5"
          width="2.5"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="6.75"
          y="5"
          width="2.5"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="11.5"
          y="5"
          width="2.5"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
